module.exports = __webpack_public_path__ + "img/fill-camera.c237cb2d.svg";